import Splide from "@splidejs/splide";
import { TABLET_WIDTH, DESKTOP_WIDTH, isDesktop } from "../constants/devices.constants";
import { emitShopifyEvent } from "../services/analytics.service";
import { applyZoom } from "../helpers/image-zoom";
const sharedSliderConfig = {
    pagination: false,
    mediaQuery: "min",
    arrows: false
};
const sharedBreakpointConfig = {
    [DESKTOP_WIDTH]: {
        destroy: true
    }
};
class ProductMainImages extends HTMLElement {
    constructor() {
        super();
        this.addEventListener("click", (event) => {
            const target = event.target;
            if (target.classList.contains('product__media--nav')) {
                emitShopifyEvent("untuckit:product_image_interaction", { interactionType: "thumbnail_click" });
            }
        });
        this.addEventListener("mouseover", (event) => {
            const target = event.target;
            if (target.closest(".product__media-slider--main") && target.nodeName === 'IMG') {
                emitShopifyEvent("untuckit:product_image_interaction", { interactionType: "main_image_hover" });
            }
        });
    }
    main;
    nav;
    onShowVideos = this.handleShowVideos.bind(this);
    zoomCleanups = [];
    connectedCallback() {
        console.log("product-main-images connected");
        const mode = this.getAttribute('mode');
        const config = this.getImageConfigByMode(mode);
        this.main = new Splide("#product-media-main", config.main);
        this.nav = new Splide("#product-media-nav", config.nav);
        this.main.sync(this.nav);
        this.main.mount();
        this.nav.mount();
        const mediaContainer = document.querySelector('.product__media-container');
        if (mediaContainer && mediaContainer.classList.contains('product__media-container--one-image')) {
            this.main.destroy();
            this.nav.destroy();
        }
        const carouselImages = document.querySelectorAll("#product-media-main .splide__slide--image");
        if (isDesktop() && carouselImages.length > 1) {
            this.zoomCleanups = Array.from(carouselImages).map(applyZoom);
        }
        window.addEventListener("product:showVideos", this.onShowVideos);
    }
    disconnectedCallback() {
        console.log("product-main-images disconnected");
        if (this.main) {
            this.main.destroy();
        }
        if (this.nav) {
            this.nav.destroy();
        }
        this.zoomCleanups.forEach(cleanup => cleanup());
        this.zoomCleanups = [];
        window.removeEventListener("product:showVideos", this.onShowVideos);
    }
    /**
     * Shows the videos on the main and nav sliders. Used for A/B testing.
     */
    handleShowVideos() {
        console.log("showing videos");
        this.querySelectorAll('.splide__slide--video').forEach(el => {
            el.classList.remove('hidden');
            el.classList.add('splide__slide');
        });
        this.main.add('.splide__slide--video');
        this.nav.add('.splide__slide--video');
    }
    getImageConfigByMode(mode) {
        switch (mode) {
            case "pdp":
                return {
                    main: {
                        ...sharedSliderConfig, ...{
                            gap: "12px",
                            type: 'loop',
                            padding: "10vw",
                            breakpoints: {
                                ...sharedBreakpointConfig, ...{
                                    [TABLET_WIDTH]: {
                                        type: 'slide',
                                        padding: "0",
                                        autoWidth: true,
                                        gap: "24px",
                                    }
                                }
                            }
                        }
                    },
                    nav: {
                        ...sharedSliderConfig, ...{
                            autoWidth: true,
                            perPage: 6,
                            isNavigation: true,
                            breakpoints: sharedBreakpointConfig
                        }
                    }
                };
            case 'quickshop':
                return {
                    main: {
                        ...sharedSliderConfig, ...{}
                    },
                    nav: {
                        ...sharedSliderConfig, ...{
                            gap: '6px',
                            autoWidth: true,
                            perPage: 6,
                            isNavigation: true
                        }
                    }
                };
            default:
                console.error(`unknown mode ${mode}; unable to determine main image config`);
                break;
        }
    }
}
if (!window.customElements.get("product-main-images")) {
    customElements.define("product-main-images", ProductMainImages);
}
